import { Paper, Rating, Stack, Typography, Box } from "@mui/material";

export default function TestimonialCard({ name, role, quote, rating, image }) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: { xs: 2.5, md: 3 },
        borderRadius: 3,
        height: "100%",
        display: "grid",
        gap: 2,
        alignContent: "start",
        transition: "transform .2s, box-shadow .2s, border-color .2s",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 10px 30px rgba(84,49,152,.12)",
          borderColor: "primary.main",
        },
      }}
    >
      {/* الصورة في الأعلى */}
      {image && (
        <Box
          component="img"
          src={image}
          alt={name}
          sx={{
            width: "100%",
            height: 180,
            borderRadius: 2,
            objectFit: "cover",
          }}
        />
      )}

      {/* الاسم والدور */}
      <Stack spacing={0.5}>
        <Typography sx={{ fontWeight: 800 }}>{name}</Typography>
        <Typography variant="caption" color="text.secondary">
          {role}
        </Typography>
      </Stack>

      {/* التقييم */}
      <Rating
        value={rating}
        precision={0.5}
        readOnly
        size="small"
        sx={{ color: "warning.main" }}
      />

      {/* الاقتباس */}
      <Typography sx={{ lineHeight: 1.9 }} color="text.secondary">
        “{quote}”
      </Typography>
    </Paper>
  );
}
